import { CompletionState } from '../../../../Logic/StudentCourseDtos'

/**
 * Build a ScenarioReportV3Dto from accumulated scoring data.
 *
 * @param {object} params
 * @param {string}  params.customLessonId
 * @param {number}  params.generationIndex
 * @param {boolean} params.triedAgain
 * @param {number}  params.timeToCompleteInSec
 * @param {number}  params.completionState   (CompletionState enum)
 * @param {object}  params.scoring           (from useLessonScoring)
 * @returns {object} ScenarioReportV3Dto
 */
export function buildScenarioReport({
    customLessonId,
    generationIndex,
    triedAgain,
    timeToCompleteInSec,
    completionState,
    scoring,
}) {
    const orderedStageResults = scoring.orderedStageResults.map((stage) => ({
        scenarioNodeId: stage.scenarioNodeId,
        scenarioNodeType: stage.scenarioNodeType,
        answerEvaluationType: stage.answerEvaluationType,
        score: stage.score,
        maxScore: stage.maxScore,
        xp: stage.xp,
        answersSubmitted: stage.answersSubmitted,
        correctAnswersSubmitted: stage.correctAnswersSubmitted,
        interactiveResults: (stage.interactiveResults || []).map((ir) => ({
            testOptionId: ir.testOptionId,
            answerEvaluationType: ir.answerEvaluationType,
            score: ir.score,
            maxScore: ir.maxScore,
            xp: ir.xp,
            answersSubmitted: ir.answersSubmitted,
            correctAnswersSubmitted: ir.correctAnswersSubmitted,
        })),
        nodeResultDto: stage.nodeResultDto || null,
    }))

    const lessonResult = {
        score: scoring.lessonScore,
        maxScore: scoring.lessonMaxScore,
        normalizedScore: scoring.normalizedScore,
        stars: scoring.hasFailed ? 0 : scoring.stars,
        hasFailed: scoring.hasFailed || false,
        xpAttained: scoring.lessonXp,
        answersSubmitted: scoring.answersSubmitted,
        correctAnswersSubmitted: scoring.correctAnswersSubmitted,
    }

    return {
        customLessonId,
        generationIndex: generationIndex || 0,
        triedAgain: triedAgain || false,
        timeToCompleteInSec: Math.round(timeToCompleteInSec),
        completionState: completionState || CompletionState.Completed,
        loadingTime: 0,
        orderedStageResults,
        lessonResult,
        migratedBecauseOfWrongScoringInApp: false,
    }
}
